import { Icon } from "../logic/scenarios/data"

export type OptionProps<T> = {
    key: T
    name: string
    description?: string
    url?: string
    icon?: Icon    
}

type ChoiceProps<T> = {
    key: string
    title: string
    question: string
    description?: string
    options: OptionProps<T>[]
    state: ChoiceState
    value?: T

    // Callback to pick a certain value for this choice and move to the next
    progress: (value: T) => void

    // Callback to jump to this choice, in case it's not the currently active choice
    jump: () => void
}

export type ChoiceState = 'INVISIBLE' | 'OPEN' | 'CLOSED'

const ChoiceIcon = ({ icon }: { icon: Icon}) => {
    if(typeof icon === 'string') {
        return <img src={`/img/wizard/${icon}`}/>
    }

    return <div style={{ backgroundColor: icon.background }} className="round-icon">
        <div style={{ color: icon.foreground }} className='round-icon-text'>{icon.text[0]}</div>
    </div>
}

const Choice = <T,>({ key, title, question, description, options, value, state, progress, jump }: ChoiceProps<T>) => {
    const selected = options.find(o => o.key === value);
    switch(state)
    {
        case 'INVISIBLE':
            return <section key={key} className="choice invisible"></section>;
        case 'CLOSED':
            return <section key={key} className="choice closed" onClick={(e) => jump()}>
                <h3>{title}</h3>
                <span>{selected && selected.name}</span>
            </section>;
        case 'OPEN':
            return <section key={key} className="choice open">
                <h3>{title}</h3>
                <p>{question} <em>{description}</em></p>                
                <div className="options">
                    {options.map(option => <a key={`${option.key}`} className={option.key==value?'selected':''} href="#" onClick={(e) => { progress(option.key) }}>
                        {option.icon && <ChoiceIcon icon={option.icon}/>}
                        {option.name}                        
                    </a>)}
                </div>
            </section>
    }
}

export default Choice